import React from "react";
import { useNavigate } from "react-router-dom";

function Start() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[100dvh] bg-white flex flex-col items-center px-6 pt-16 pb-[calc(3rem+env(safe-area-inset-bottom))]">
      <div className="w-full flex flex-col items-center text-center">
        <div className="w-full max-w-md mx-auto mb-10">
          <img
            src="/start_video.gif"
            alt="start animation"
            className="w-full h-[300px] object-cover"
          />
        </div>

        {/* 타이틀 */}
        <div className="flex flex-col items-center gap-6">
          <img
            src="/logo.png"
            alt="WINGSTEP"
            className="h-[62px] object-contain"
          />

          <p className="text-gray-500 text-base px-8 leading-relaxed">
            운동을 즐기며 성장하는
            <br />
            라이프 플랫폼
          </p>
        </div>
      </div>

      {/* 버튼 영역 */}
      <div className="w-full max-w-sm space-y-4 mt-auto pt-10">
        {/* 회원가입 버튼 */}
        <button
          onClick={() => navigate("/signup")}
          className="w-full py-4 text-white rounded-2xl font-bold text-base shadow-md hover:shadow-lg transition-all uppercase"
          style={{ backgroundColor: "rgb(0, 224, 198)" }}
        >
          첫 걸음 시작
        </button>

        {/* 로그인 버튼 */}
        <button
          onClick={() => navigate("/login")}
          className="w-full py-4 bg-white border-2 rounded-2xl font-bold text-base transition-all uppercase"
          style={{
            borderColor: "rgb(230, 230, 230)",
            color: "rgb(0, 224, 198)",
          }}
        >
          로그인
        </button>
      </div>
    </div>
  );
}

export default Start;
